import React, { useState, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  RouterNavLink,
  NavBtn,
  NavBtnLeft,
  NavBtnRight,
  NavBtnLink,
} from "./NavbarElements";
import logo from "../../images/logo (6).jpg";

export const Navbar = ({ toggle }) => {
  const [scrollNav, setScrollNav] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
    return () => window.removeEventListener("scroll", changeNav);
  }, []);

  const isHome = location.pathname === "/";

  const navItems = [
    { id: "ACTS", label: "ACTS" },
    { id: "ACRFC", label: "ACRFC" },
    { id: "ACREM", label: "ACREM" },
    { id: "ACPMM", label: "ACPMM" },
    { id: "ACRCM", label: "ACRCM" },
    { id: "about", label: "Partners" },
    { id: "Donate", label: "Donate" },
  ];

  const handleNavClick = (id) => {
    if (!isHome) {
      navigate(`/?scrollTo=${id}`);
    } else {
      scroller.scrollTo(id, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    }
  };

  return (
    <Nav scrollNav={scrollNav}>
      <NavbarContainer>
        <NavLogo to="/">
          <img src={logo} alt="Logo" />
        </NavLogo>
        <MobileIcon onClick={toggle}>
          <FaBars />
        </MobileIcon>
        <NavMenu>
          {navItems.map((item) => (
            <NavItem key={item.id}>
              {isHome ? (
                <NavLinks
                  to={item.id}
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {item.label}
                </NavLinks>
              ) : (
                <RouterNavLink onClick={() => handleNavClick(item.id)}>
                  {item.label}
                </RouterNavLink>
              )}
            </NavItem>
          ))}
        </NavMenu>
        <NavBtnLeft>
          <NavBtnLink to="/signin">Sign In</NavBtnLink>
        </NavBtnLeft>
        <NavBtnRight>
          <NavBtnLink to="/books">Courses</NavBtnLink>
          <NavBtnLink to="/admin/upload">Upload</NavBtnLink>
        </NavBtnRight>
      </NavbarContainer>
    </Nav>
  );
};
